import { ProfessionalContractTypeFilterKeyString } from 'InstitutionalManagement/types'
import { PROFESSIONAL_CONTRACT_TYPE_FIELDS_INITIAL_VALUES } from './professionalContractTypeFieldsInitialValues'

export const PROFESSIONAL_CONTRACT_TYPE_INITIAL_FILTER: ProfessionalContractTypeFilterKeyString = {
  search: '',
  ...PROFESSIONAL_CONTRACT_TYPE_FIELDS_INITIAL_VALUES,
}
